import React, { useEffect, useState } from "react";
import BulkUploadCarrierChangeModal from "../../components/BulkUploadCarrierChange";

const BulkUploadCarrierChangeManager = (props) => {
  return <BulkUploadCarrierChangeModal />;
};

export default BulkUploadCarrierChangeManager;
